<ion-card>
  <ion-card-header>
    <ion-toolbar>
      <ion-icon slot="start" size="large" [src]="'format-list-checks' | getIcon"></ion-icon>
      <ion-title>Esami prescritti</ion-title>
    </ion-toolbar>
  </ion-card-header>

  <ion-card-content>
    <ion-toolbar>
      <ion-buttons slot="end">
        <!-- select all -->
        <ion-button (click)="sostitusciPdta()" color="secondary" fill="solid">
          <ion-icon slot="start" [src]="'checkbox-multiple-marked-outline' | getIcon"> </ion-icon>
          <span class="ion-hide-md-down">Sostituisci pdta</span>
        </ion-button>
        <!-- select all -->
        <ion-button (click)="onSelectAll()" color="secondary" fill="solid">
          <ion-icon slot="start" [src]="'checkbox-multiple-marked-outline' | getIcon"> </ion-icon>
          <span class="ion-hide-md-down">Seleziona tutto</span>
        </ion-button>

        <!-- deselect all -->
        <ion-button (click)="onDeselectAll()" color="secondary" fill="solid">
          <ion-icon slot="start" [src]="'checkbox-multiple-blank-outline' | getIcon"> </ion-icon>
          <span class="ion-hide-md-down">Deseleziona tutto</span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <!-- lista esami -->
    <ion-spinner color="secondary" *ngIf="loading$ | async"></ion-spinner>
    <div *ngIf="availableEsamiPdta">
      <div *ngFor="let item of availableEsamiPdta.pdtaEntry | keyvalue; let j = index">
        <ion-accordion-group [value]="item.key" expand="inset" *ngIf="item.value.length > 0">
          <ion-accordion [value]="item.key" toggleIcon="caret-down-circle" toggleIconSlot="end">
    
            <ion-item slot="header"
                      [ngClass]="(trimestreCorrente === item.key ? 
                  'item-trimestre-corrente-color' : item.key === '-1' ? 'item-esami-singoli-color' : 'item-trimestre-not-corrente-color')">
              <ion-label *ngIf="item.key != '-1' && item.key != '-2' && item.key != 'O'">{{item.key}} <span
                      *ngIf="item.key === '1' || item.key === '2' || item.key === '3'">
                  Trimestre</span></ion-label>
              <ion-label *ngIf="item.key === '-1'"> Esami singoli</ion-label>
              <ion-label *ngIf="item.key==='-2'"> Esami periodici</ion-label>
              <ion-label *ngIf="item.key === 'O'"> Esami facoltativi</ion-label>
            </ion-item>
    
            <div *ngFor="let esamiPdta of item.value" class="margin-left" slot="content">
              <div *ngIf="item.key === 'O'">
                <ion-row>
                  <ion-col size="8">
                    <ion-item>
                      <ion-checkbox slot="start" [(ngModel)]="esamiPdta.checked">
                      </ion-checkbox>
                      <ion-label class="ion-text-wrap">{{esamiPdta.descrizione}}
                        <span *ngIf="esamiPdta.nome">
                          - {{ esamiPdta.nome}}
                        </span>
                        <span *ngIf="esamiPdta.tempo">
                          ( {{
                          esamiPdta.tempo }} )
                        </span></ion-label>
                    </ion-item>
                  </ion-col>
                  <ion-col size="3" *ngIf="parentContext === CTXS_PARENT.GRAVIDANZA" class="c3-flex ion-align-items-end">
                    <!-- trimestre selection -->
                    <ion-item class="c3-full-width">
                      <ion-select class="select-full-width" placeholder="Seleziona trimestre"
                                  (ionChange)="trimestreSelectionChange($event, esamiPdta)" interface="popover" [interfaceOptions]="{
                            showBackdrop: false,
                            cssClass: 'app-popover-select app-popover-select-overflow'
                          }">
                        <ion-select-option [value]="TipoEsami.TRIMESTRE_1">1 trimestre</ion-select-option>
                        <ion-select-option [value]="TipoEsami.TRIMESTRE_2">2 trimestre</ion-select-option>
                        <ion-select-option [value]="TipoEsami.TRIMESTRE_3">3 trimestre</ion-select-option>
                      </ion-select>
                    </ion-item>
                  </ion-col>
                  <ion-col size="1" class="c3-flex ion-align-items-center ion-justify-content-center">
                    <ion-item lines="none">
    
                      <ion-button size="small" (click)="aggiungiEsame(esamiPdta)" color="secondary" fill="solid">
                        <ion-icon slot="icon-only" size="small" [src]="'plus' | getIcon"></ion-icon>
                      </ion-button>
    
                    </ion-item>
                  </ion-col>
    
                </ion-row>
    
              </div>
              <div *ngIf="item.key != 'O'">
                <ion-item>
                  <ion-checkbox slot="start" [(ngModel)]="esamiPdta.checked">
                  </ion-checkbox>
                  <ion-label class="ion-text-wrap">{{esamiPdta.descrizione}}
                    <span *ngIf="esamiPdta.nome">
                      - {{ esamiPdta.nome}}
                    </span>
                    <span *ngIf="esamiPdta.tempo">
                      ( {{
                      esamiPdta.tempo }} )
                    </span></ion-label>
                  <ion-chip class="chip" color="secondary" *ngIf="esamiPdta.prescritto">
                    <div class="row">
                      <div class="col-md-12">Prescritto il</div>
                      <div class="col-md-12">{{esamiPdta.prescritto}}</div>
                    </div>
                  </ion-chip>
    
                  <ion-chip class="chip" color="primary" *ngIf="esamiPdta.prenotato">
                    <div class="row">
                      <div class="col-md-12">Prenotato per il</div>
                      <div class="col-md-12">{{esamiPdta.prenotato}}</div>
                    </div>
                  </ion-chip>
    
                  <ion-chip class="chip" color="success" *ngIf="esamiPdta.eseguito">
                    <div class="row">
                      <div class="col-md-12">Eseguito</div>
                    </div>
                  </ion-chip>
                </ion-item>
              </div>
            </div>
          </ion-accordion>
        </ion-accordion-group>
    
    
      </div>
    </div>

    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-spinner color="secondary" *ngIf="loading$ | async"></ion-spinner>

        <ion-button color="secondary" fill="solid" (click)="prepareSaveDataAction()" [disabled]="loading$ | async">
          <span>Salva</span>
          <ion-icon slot="end" [src]="'content-save' | getIcon"></ion-icon>
        </ion-button>
        <ion-button color="secondary" fill="solid" (click)="prescriviEsami()" *ngIf="availableEsamiPdta && (availableEsamiPdta.pdtaEntry | keyvalue)?.length > 0" [disabled]="loading$ | async">
          <span>Prescrivi/Prenota</span>
          <ion-icon slot="end" name="reader-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-card-content>
</ion-card>